import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LandingPage() {
  const [restaurantId, setRestaurantId] = useState("1");
  const [tableNumber, setTableNumber] = useState("1");
  const navigate = useNavigate();

  return (
    <div className="page">
      <div className="brand-bar">
        <h1>ODRA</h1>
        <div className="sub">Scan a table's QR code to view the menu and order.</div>
      </div>

      <div className="card" style={{ marginTop: 24 }}>
        <h2 style={{ marginTop: 0 }}>No QR code handy?</h2>
        <p className="muted">
          Enter the restaurant ID and the table number printed on your
          table (the same number you'd see on the table card in the
          dining room).
        </p>
        <label>
          Restaurant ID
          <input
            value={restaurantId}
            onChange={(e) => setRestaurantId(e.target.value)}
            style={{ marginLeft: 8, padding: 6 }}
            inputMode="numeric"
          />
        </label>
        <br />
        <br />
        <label>
          Table number
          <input
            value={tableNumber}
            onChange={(e) => setTableNumber(e.target.value)}
            style={{ marginLeft: 8, padding: 6 }}
            inputMode="numeric"
          />
        </label>
        <div style={{ marginTop: 16 }}>
          <button
            className="btn"
            onClick={() =>
              navigate(
                `/order?restaurant_id=${restaurantId}&table_number=${tableNumber}`
              )
            }
          >
            Open menu &rarr;
          </button>
        </div>
      </div>
    </div>
  );
}
